<template>
  <div class="c-text-input">
    <label
      v-if="label"
      class="c-text-input__label"
      :for="formId"
    >{{ label }}</label>
    <slot />
    <input
      ref="form-input-ref"
      v-model="localValue"
      class="c-text-input__control t-heading-7"
      type="text"
      :autocomplete="autocomplete"
      :class="iconClass"
      :disabled="disabled"
      :maxlength="inputMaxLength"
      :name="formId"
      :placeholder="placeholder"
      :required="required"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
      @keydown="$emit('keydown', $event)"
      @keyup="$emit('keyup', $event)"
      @mouseup="$emit('mouseup', $event)"
    >
  </div>
</template>

<script>
export default {
  name: "FormInput",
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    label:{
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      default: 0
    },
    required: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: 'on'
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    iconClass() {
      const icon = this.icon
      let result = 'c-text-input__control--no-icon'
      if (icon) {
        result = `c-text-input__control--${icon}`
      }
      return result
    },
    formId() {
      const id = this.id
      const uid = this._uid
      return id || uid
    },
    inputMaxLength() {
      const maxLength = this.maxlength
      return (maxLength === 0) ? undefined : maxLength
    }
  },
  methods: {
    focus() {
      this.$refs['form-input-ref'].focus()
    },
    setSelectionRange(a, b) {
      this.$refs['form-input-ref'].setSelectionRange(a, b)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-text-input {
  width: 100%;
  &__label {
    padding: rem(10px);
  }
  &__control {
    text-align: inherit;
    font-family: inherit;
    padding: $input-padding;
    border: $input-border;
    position: relative;
    width: 100%;
    text-transform: unset;
    @include themify($themes){
      color: themed("primary", "form");
      background-color: themed("background", "form");
      border-color: themed("foreground", "input-border");
    }
    &:focus {
      outline: none;
    }
    &:focus,
    &:hover {
      @include themify($themes) {
        border-color: themed('foreground');
      }
    }
    &--envelope {
      background-image: url('~@/assets/icons/envelope.svg');
      background-repeat: no-repeat;
      background-size: rem(19px);
      background-position: rem(9px) center;
    }
    &--search {
      background-image: url('~@/assets/icons/search.svg');
      background-repeat: no-repeat;
      background-size: rem(19px);
      background-position: rem(9px) center;
    }
    &--no-icon {
      padding-left: 10px;
    }
  }
  &--invalid {
    input {
      @include themify($themes) {
        border-color: themed("foreground", "error");
      }
    }
  }
}
</style>
